<template>
  <section class="cursos">
    <h1>Cursos</h1>

    <div class="content">
      <div class="cards__container">
        
        <div class="novo-curso">
          <router-link :to="routerLink">
            <div class="novo-curso-img__container">
              <img src="@/assets/icons/new-curso.svg">
            </div>
          </router-link>
        </div>
       
        <template v-for="(course, index) in courses">
          <Course :key="index" :course="course" />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import Course from '@/components/atomic/organisms/Course.vue';

export default {
  name: 'Courses',

  components: {
    Course,
  },

  props: {
    courses: { type: Array, required: true },
    routerLink: { type: String, required: false, default: '/teacher/courses' },
  },
};
</script>

<style lang="scss" scoped>
.cursos {
  h1 {
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    font-size: 30px;
    line-height: 34px;
    color: rgba(51, 50, 56, 0.84);
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .cards__container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
    }

    .novo-curso {
      width: 100%;
      max-width: 348px;
      height: 333px;
      margin: 9px 9px;
      background: #fff;
      box-shadow: 0px 0px 0px 1px rgba(63, 63, 68, 0.05),
        0px 1px 3px rgba(63, 63, 68, 0.15);
      border-radius: 4px;

      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      a {
        display: flex;
        text-decoration: none;
        color: inherit;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
